<template>
  <!-- The Modal -->
  <div class="modal fade" id="myModal">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">新增周邊資訊</h4>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            @click="deleteModalData"
          ></button>
        </div>

        <!-- Modal body -->
        <div class="modal-body" style="display: flex; background: #f1f0f061">
          <!-- 左側圖片區 -->
          <div
            style="
              display: flex;
              flex: 3;
              justify-content: space-evenly;
              flex-direction: column;
              align-items: center;
              padding-right: 10px;
            "
          >
            <div class="input-group mb-3">
              <label
                class="btn btn-outline-primary input-group-text"
                for="inputGroupFile01"
                >Upload</label
              >
              <input type="file" class="form-control" id="inputGroupFile01" />
            </div>
            <div
              class="border border-1 shadow-sm p-3 mb-5 bg-body rounded"
              style="
                width: 400px;
                height: 400px;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                style="border-radius: 5%"
                src="https://cf.shopee.tw/file/5325103cd678afe8f502b1d939c48b46"
                width="350"
                height="350"
              />
            </div>
          </div>
          <div
            style="display: flex; flex: 4; flex-direction: column; width: 100%"
          >
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >商品名稱</span
              >
              <input
                type="text"
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                v-model="objectMerchandiseData.merchandiseName"
              />
            </div>
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >角色名稱</span
              >
              <input
                type="text"
                class="form-control"
                placeholder="逗號分隔角色 例如：友也,創,司,凜月,嵐"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                v-model="objectMerchandiseData.roleName"
              />
            </div>
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >商品原價</span
              >
              <input
                type="text"
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                v-model="objectMerchandiseData.merchandiseOriginalPrice"
              />
            </div>
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >購買雜費</span
              >
              <input
                type="text"
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                v-model="objectMerchandiseData.merchandiseMiscellaneous"
              />
            </div>
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >商品總價</span
              >
              <input
                type="text"
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                v-model="objectMerchandiseData.merchandiseTotalPrice"
              />
            </div>
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >商品來源</span
              >
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="objectMerchandiseData.merchandiseSource"
              >
                <option selected disabled>請選擇商品來源</option>
                <option value="全新">全新</option>
                <option value="二手">二手</option>
                <option value="其他">其他</option>
              </select>
            </div>
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >購買平台</span
              >
              <select
                class="form-select"
                aria-label="Default select example"
                v-model="objectMerchandiseData.merchandiseShoppingPlatform"
              >
                <option selected disabled>請選擇購買平台</option>
                <option value="露天拍賣">露天拍賣</option>
                <option value="蝦皮拍賣">蝦皮拍賣</option>
                <option value="安利美特">安利美特</option>
                <option value="Facebook">Facebook</option>
                <option value="Mercari">Mercari</option>
              </select>
            </div>
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >商品備註</span
              >
              <textarea
                class="form-control"
                placeholder="Leave a comment here"
                id="floatingTextarea"
                v-model="objectMerchandiseData.merchandiseNote"
              ></textarea>
            </div>
            <div class="input-group input-group-sm mb-3">
              <span class="input-group-text" id="inputGroup-sizing-sm"
                >購入日期</span
              >
              <input
                id="todayDate"
                type="date"
                class="form-control"
                aria-label="Sizing example input"
                aria-describedby="inputGroup-sizing-sm"
                v-model="objectMerchandiseData.merchandisePurchaseDate"
              />
            </div>
          </div>
        </div>
        <!-- Modal footer -->
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            v-if="!isEditedStatus"
            @click="addMerchandiseData"
            data-bs-dismiss="modal"
          >
            新增
          </button>
          <button
            class="btn btn-primary"
            v-if="isEditedStatus"
            @click="editedMerchandiseData"
            data-bs-dismiss="modal"
          >
            編輯
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "../EventBus.js";
export default {
  data() {
    return {
      // data-bs-dismiss="modal"
      objectMerchandiseData: {
        merchandiseName: "", // 商品名稱
        roleName: "", // 角色名稱
        merchandiseOriginalPrice: "", // 商品原價
        merchandiseMiscellaneous: "", // 商品雜費
        merchandiseTotalPrice: "", // 商品總價
        merchandiseSource: "", // 商品來源
        merchandiseShoppingPlatform: "", // 商品購入平台
        merchandiseNote: "", // 商品備註
        merchandisePurchaseDate: "", // 購入日期
      },
      tempToday: "",
      isEditedStatus: false,
    };
  },
  methods: {
    // emit 把新增的資料傳到 home.vue 顯示, 並清除資料
    addMerchandiseData() {
      bus.emit("addMerchandiseData", this.objectMerchandiseData);
      console.log("emit");

      this.deleteModalData();
    },
    // 檢視商品詳細資訊
    checkMerchandiseData(merchandiseData) {
      this.objectMerchandiseData = Object.assign({}, merchandiseData);
      console.log(this.objectMerchandiseData);
      this.isEditedStatus = true;
    },
    // 編輯完成 emit 回去, 清資料
    editedMerchandiseData() {
      bus.emit("editedMerchandiseData", this.objectMerchandiseData);
      this.deleteModalData();
    },
    // 新增或編輯或關閉時, 清除 input 資料並補上日期 (日期沒要清除), 編輯按鈕=>新增按鈕
    deleteModalData() {
      Object.keys(this.objectMerchandiseData).forEach(
        (k) => delete this.objectMerchandiseData[k]
      );
      this.objectMerchandiseData.merchandisePurchaseDate = this.tempToday;
      this.isEditedStatus = false;
    },
  },
  created() {
    let now = new Date();
    //格式化"日"，如果小於9，前面補0
    let day = ("0" + now.getDate()).slice(-2);
    //格式化"月"，如果小於9，前面補0
    let month = ("0" + (now.getMonth() + 1)).slice(-2);
    let today = now.getFullYear() + "-" + month + "-" + day;
    this.tempToday = today;
    this.objectMerchandiseData.merchandisePurchaseDate = today;
    // 監聽 點擊 info 傳送商品資訊的 emit 事件, 然後執行 checkMerchandiseData() 顯示資料
    bus.on("clickMerchandiseData", this.checkMerchandiseData);
  },
};
</script>
